import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'uni-card-header-item',
  templateUrl: './uni-card-header-item.component.html',
  styleUrls: ['./uni-card-header-item.component.scss'],
})
export class UniCardHeaderItemComponent {
  @HostBinding('class.is-last') @Input() isLast = false;
}
